import React, { useEffect, useState } from 'react';
import { PeriodoDescripciones } from '../../../../../infraestructure/persistence/rest/PeriodosAdapter';
import { EuiFieldNumber } from '@elastic/eui';


export const SelectorEjercicio = (props:any) =>{

  let { onChange, minVal, maxVal} = props;

  const onChangeAño = (e:any) => {
    onChange(parseInt(e.target.value))
  }
  
  console.log('selectorEjercicio', props);

  return (
    <EuiFieldNumber {...props} placeholder="Año a filtrar ..." onChange={(e) => onChangeAño(e)} min={minVal} max={maxVal}/>
  )
}
export default SelectorEjercicio